import AtlasSelection from './AtlasSelection.js';
import Context from './Context.js';
import SnapOnCurveElement from './SnapOnCurveElement.js';
import SnapOnFaceElement from './SnapOnFaceElement.js';
import { SnapPointBaseElement, SnapPointSelectionObject } from './SnapPointBaseElement.js';
import { SnapPointElement, SnapPointExtension } from './SnapPointElement.js';
import atlasSelectionUtils from './atlasSelectionUtils';
import BasicElements, { SelectionElement, SelectionObject } from './core-elements/BasicElements.js';
import secondarySelectionColor from './secondarySelectionColor';

// SelectionElement, SelectionObject is exported in BasicElements as value type, export them as class type again for VsCode intellisence.
export {
    AtlasSelection,
    BasicElements,
    Context,
    SelectionElement,
    SelectionObject,
    SnapOnCurveElement,
    SnapOnFaceElement,
    SnapPointBaseElement,
    SnapPointElement,
    SnapPointExtension,
    SnapPointSelectionObject,
    atlasSelectionUtils,
    secondarySelectionColor
};
export default {
    BasicElements,
    SelectionElement,
    SelectionObject,
    SnapPointSelectionObject,
    SnapPointBaseElement,
    SnapPointElement,
    SnapPointExtension,
    SnapOnFaceElement,
    SnapOnCurveElement,
    Context,
    AtlasSelection,
    atlasSelectionUtils,
    secondarySelectionColor
};
